import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { ChevronRight } from 'lucide-react';
import { formatDate } from './utils';

export default function ArchivedCallCard({ call }) {
  const navigate = useNavigate();
  return (
    <Card
      className="bg-card/50 border-border/30 hover:border-primary/30 transition-colors cursor-pointer"
      onClick={() => navigate(`/report/${call.call_id}`)}
    >
      <CardContent className="p-5">
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center gap-3 mb-1">
              <h3 className="font-medium text-foreground">{call.title}</h3>
              <Badge variant="outline" className="text-xs capitalize">
                {call.archive_category}
              </Badge>
            </div>
            <p className="text-sm text-muted-foreground">
              {formatDate(call.call_date || call.created_at)}
            </p>
          </div>
          <ChevronRight className="w-5 h-5 text-muted-foreground" />
        </div>
      </CardContent>
    </Card>
  );
}
